/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DekitusIntroduction.vue?vue&type=template&id=5e25b49a&scoped=true&"
var script = {}
import style0 from "./DekitusIntroduction.vue?vue&type=style&index=0&id=5e25b49a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e25b49a",
  null
  
)

export default component.exports